import Modal from 'react-responsive-modal';
import { Button } from '../../../../components/Button';
import { useAuth } from '../../../../hooks/useAuth';
import { formatMoney } from '../../../../utils/formatMoney';
import { numberWithCommas } from '../../../../utils/numberWithCommas';
import styles from './style.module.css';
import { usePoints } from '../../../../hooks/usePoints';

interface IDetailsAward {
  modalIsOpen: boolean;
  toggleModalIsOpen: () => void;
  award?: {
    premiumName?: string;
    premiumDescription?: string;
    premiumPrice?: number;
    premiumImage?: string;
    valueType?: {
      label?: string;
      value?: string;
    };
    premiumType?: {
      label: string;
      value: string;
    };

    paymentValue?: string;
  };
}

export const ModalDetailsAward = ({
  award,
  modalIsOpen,
  toggleModalIsOpen,
}: IDetailsAward) => {
  const { client } = useAuth();
  const { availableToRedeem } = usePoints();

  const points =
    (award && !award.valueType) || award?.valueType?.value === 'fixed'
      ? numberWithCommas(award?.premiumPrice ? award?.premiumPrice : 0)
      : numberWithCommas(availableToRedeem);

  const isAwardMoney = award?.premiumType && award?.premiumType.value === 'BS2';
  const isAwardVariable =
    award?.valueType && award?.valueType.value === 'variable';

  return (
    <Modal open={modalIsOpen} onClose={toggleModalIsOpen}>
      <div className="contents-modal">
        <h1 className="title-modal">{award?.premiumName}</h1>
        <div className={`mb-4 ${styles.containerImageRescue}`}>
          <img src={award?.premiumImage} alt="" className={styles.img} />
        </div>
        <p className="subtitle-modal">{award?.premiumDescription}</p>
        <div className="mb-3 mt-3 d-flex flex-column align-items-center">
          <span>
            {award?.premiumPrice === 1
              ? `${points} ${client?.coinName ? client.coinName.replace(/\(\w*\)/g, '') : 'ponto'}`
              : `${points} ${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'}`}
          </span>

          {isAwardMoney && !isAwardVariable && (
            <span>{formatMoney(award?.paymentValue)}</span>
          )}

          {isAwardMoney && isAwardVariable && (
            <span>{formatMoney(availableToRedeem)}</span>
          )}
        </div>
      </div>
      <div className={styles.contentBtn}>
        <Button
          isModal
          text="Fechar"
          type="button"
          color="primary"
          onClick={toggleModalIsOpen}
        />
      </div>
    </Modal>
  );
};
